module.exports = __webpack_public_path__ + "img/undraw_Celebration_re_kc9k.e0485d0f.svg";